
/**
 * 去除mongo中获取到的与展示无关的时间标记
 * @param {string} str
 * @returns {string} str
 */
export function timeFormat (str) {
  // 2020-08-07T14:30:42.234+08:00
  return str.replace(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})(:.*)/g, '$1 $2')
}

/**
 * 将秒转化成 时:分:秒
 * @param {Object} time
 */
export function durationFormat (time) {
  // version1
  // let min = time / 60;
  // let sec = time % 60;
  // return Math.floor(min).toString().padStart(2,'0') + ':' +  Math.ceil(sec).toString().padStart(2,'0')

  // version2
  return '0'.repeat(2 - String(Math.floor(time / 60)).length) + Math.floor(time / 60) + ':' + '0'.repeat(2 - String(Math.floor(time % 60)).length) + Math.floor(time % 60)
}

/**
 * 获取当前时间
 */
export function getCurrentTime () {
  return new Date().getTime()
  // return Math.round(new Date().getTime()/1000)  //Unix时间
}

export function formatUnixTime (time) {
  var date = new Date(time * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const YYYY = date.getFullYear()
  let MM = date.getMonth() + 1
  let DD = date.getDate()
  let hh = date.getHours()
  let mm = date.getMinutes()
  let ss = date.getSeconds()

  MM = MM < 10 ? ('0' + MM) : MM
  DD = DD < 10 ? ('0' + DD) : DD
  hh = hh < 10 ? ('0' + hh) : hh
  mm = mm < 10 ? ('0' + mm) : mm
  ss = ss < 10 ? ('0' + ss) : ss

  return YYYY + '-' + MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss
}
